//import angular from 'angular';
import AdminUrls from '../../../adminUrls';

angular.module('app.admin').controller("traCodeSearchCtrl", traCodeSearchCtrl);

    // @ts-ignore
    traCodeSearchCtrl.$inject = ["adminUrls", "$scope", "enums", "ocSecuritySvc", "amtXlatSvc", "$timeout", "WindowFactory", "ocConfigSvc", "exportSvc", "helperSvc", "referenceDataUrls"];

    // ReSharper disable once InconsistentNaming
    function traCodeSearchCtrl(adminUrls: AdminUrls, $scope, enums, ocSecuritySvc, amtXlatSvc, $timeout, WindowFactory, ocConfigSvc, exportSvc, helperSvc, referenceDataUrls) {

        var vm = this;

        vm.processing = false;

        vm.adminUrls = adminUrls;        
        vm.referenceDataUrls = referenceDataUrls;

        vm.config = ocConfigSvc;

        vm.enums = enums;

        vm.criteria = {
            filterValues: {               
                activeOptions: null,
                traCodeIds: null                
            }
        };

        vm.traCodeFilterControl = {};

        vm.activeOptions = [{
            name: amtXlatSvc.xlat('common.yes_label'),
            key: true
        }, {
            name: amtXlatSvc.xlat('common.no_label'),
            key: false
        }];

        vm.status = enums.screenStatus.loading;

        vm.gridControl = {};
        vm.selectedItem = null;

        function init() {
            vm.loadDefaults();
        }

        vm.onSelectedItemChanged = function (items) {
            if (items != null && items.length === 1) {
                vm.selectedItem = items[0];
            } else {
                vm.selectedItem = null;
            }
        };

        vm.setHeaderHeight = function (height, offset) {
            vm.gridTop = height + offset;
        };

        vm.loadDefaults = function () {
            vm.defaults = {
                activeOptions: [vm.activeOptions[0]]
            };

            vm.status = enums.screenStatus.ready;
        };

        vm.export = function () {
            exportSvc.exportData(vm.referenceDataUrls.exportTRACodes, vm.criteria, amtXlatSvc.xlat('traCode.searchTitle'));
        };

        $scope.editTRACode = function (item) {
            if (item) {
                WindowFactory.openItem({
                    component: 'add-edit-tra-code',
                    caption: amtXlatSvc.xlat("traCode.edit"),
                    initParams: item,
                    width: 550,
                    onDataChangeHandler: function () {
                        vm.refreshGrid();
                        vm.traCodeFilterControl.search();
                    },
                    windowRelatedRecordId: item.id
                });
            }
        };

        $scope.addTRACode = function () {
            WindowFactory.openItem({
                component: 'add-edit-tra-code',
                caption: amtXlatSvc.xlat("traCode.add"),
                initParams: null,
                width: 550,
                onDataChangeHandler: function () {
                    vm.refreshGrid();
                    vm.traCodeFilterControl.search();
                }
            });
        };

        vm.refreshGrid = function () {
            vm.gridControl.refresh();
        };

        init();
    }
